import React from "react";
import { Row, Col, Collapse, CardBody, DropdownToggle } from "reactstrap";
import { addClassName } from "../../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../../Utils/calculate-progress.js";

import DropDown from "../DropDown/DropDown";
import Devplan from "../DropDown/Devplan-dropdown";

import MyReportsIcon from "../../../../../images/new-images/myreports.png";
import completed from "../../../../../images/new-images/completed.png";
import "./DownloadReports.css";
import ResponsiveDashboardcardlayout from "../../../Layout/ResponsiveLayout.jsx";


const ResponsiveDownloadReports = (props) => {



  const newFilteredData = [];
  props.assessmentDetails &&
    props.assessmentDetails.respondents.filter((onlyFilterData) => {
      if (onlyFilterData.assessment_status__status_name == "Completed") {
        return newFilteredData.push(onlyFilterData);
      }
    });

  const isVVI = props.assessmentDetails && props.assessmentDetails.instrument__instrument_name === "VVI";


  return (
    <ResponsiveDashboardcardlayout headerIcon={MyReportsIcon} headerText="My Reports" marginStyle='dashboard-summary'>
      <div className="Responsive-Download-Reports">
        {props.checkMultiRater == true ? (
          <React.Fragment>
            <div className="assessment-details">
              {props.assessmentDetails && props.assessmentDetails.instrument__instrument_image && (
                <img
                  className="assessmentIcon"
                  src={
                    localStorage.getItem("baseLink") +
                    `/media/` +
                    props.assessmentDetails.instrument__instrument_image
                  }
                  alt="Assessment Icon"
                />
              )}
              <p className="assessmentName">
                {props.assessmentDetails &&
                  props.assessmentDetails.instrument__dashboard_header_text}
              </p>
            </div>
            <p className="userName">
              {props.assessmentDetails &&
                props.assessmentDetails.participant__full_name}
              {props.assessmentDetails && props.assessmentDetails.participant__full_name && (
                <span style={{ textTransform: "lowercase", marginRight: '5px' }}>'s</span>
              )}
              {props.assessmentDetails &&
                props.assessmentDetails.instrument__instrument_name}
            </p>
            <p className="report-text">
              {props.devPlanList.length == 0 &&
                props.downloadReportDropdown.length == 0
                ? "No Reports are avaliable for download"
                : "Congratulations! Your reports are ready for download."}
            </p>
            <div className="drop-down">
              <Devplan
                devPlan={props.devPlan}
                devPlanList={props.devPlanList}
                handleDevPlanDownload={props.handleDevPlanDownload}
                assessmentDetails={props.assessmentDetails}
              />
              <DropDown
                downloadReportDropdown={props.downloadReportDropdown}
                handlePdfDownload={props.handlePdfDownload}
                enable_report={props.assessmentDetails.enable_report}
              />
            </div>
            {newFilteredData.map((getRespondants, index) => (
              <React.Fragment key={index}>
                <Row className='header'>
                  {getRespondants.participant__full_name == null ? (
                    getRespondants.respondent__email
                  ) : (
                    getRespondants.participant__full_name
                  )}
                  <i onClick={() => props.toggleCollapse(getRespondants.id)}
                    className={props.collapseID === getRespondants.id ? "fas fa-angle-up" : "fa fa-angle-down"}
                    aria-hidden="true" />
                </Row>
                <hr />
                <Collapse isOpen={props.collapseID === getRespondants.id}>
                  <CardBody>
                    {getRespondants.participant__full_name == null ? ('') : (
                      <Row>
                        <Col className="title">Email</Col>
                        <Col className="details">
                          {getRespondants.respondent__email}
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col className="title">Relationship</Col>
                      <Col className="details">
                        {getRespondants.assessor_group__assessor_name}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="title">Status</Col>
                      <Col>
                        {getRespondants.assessment_status__status_name ===
                          "In progress" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                getRespondants.assessment_status__status_name
                              )
                            }
                          >
                            {getRespondants.assessment_status__status_name}
                            {calcPercentage(
                              getRespondants.assessment_number_count,
                              getRespondants.assessment_completed_count
                            )}
                          </div>
                        ) : getRespondants.assessment_status__status_name ===
                          "Completed" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                getRespondants.assessment_status__status_name
                              )
                            }
                          >
                            {getRespondants.assessment_status__status_name}
                            <img src={completed} alt="Completed Image" />
                          </div>
                        ) : (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                getRespondants.assessment_status__status_name
                              )
                            }
                          >
                            {getRespondants.assessment_status__status_name}
                          </div>
                        )}
                      </Col>
                    </Row>
                  </CardBody>
                </Collapse>
                <hr />
              </React.Fragment>
            ))}
          </React.Fragment>
        ) : (
          <div>
            <div className="assessment-details">
              {props.assessmentDetails && props.assessmentDetails.instrument__instrument_image && (
                <img
                  className="assessmentIcon"
                  src={
                    localStorage.getItem("baseLink") +
                    `/media/` +
                    props.assessmentDetails.instrument__instrument_image
                  }
                  alt="Assessment Icon"
                />
              )}
              <p className="assessmentName">
                {props.assessmentDetails &&
                  props.assessmentDetails.instrument__dashboard_header_text}
              </p>
            </div>
            <p className="userName">
              {props.assessmentDetails &&
                props.assessmentDetails.participant__full_name}
              {props.assessmentDetails && props.assessmentDetails.participant__full_name && "'s"}
              {props.assessmentDetails &&
                props.assessmentDetails.instrument__instrument_name}
            </p>
            <p className="report-text">
              Congratulations! Your reports are ready for download.
            </p>
            <div className={`drop-down ${isVVI ? "justify-center" : ""}`}>
              {!isVVI && (
                <div>
                  {props.devPlanList.length === 0 ? (
                    <DropdownToggle className="disabled">DOWNLOAD DEV PLAN</DropdownToggle>
                  ) : (
                    <Devplan
                      devPlan={props.devPlan}
                      devPlanList={props.devPlanList}
                      handleDevPlanDownload={props.handleDevPlanDownload}
                      handleSelfDevPlanDownload={props.handleSelfDevPlanDownload}
                      assessmentDetails={props.assessmentDetails}
                    />
                  )}
                </div>
              )}

              {props.downloadReportDropdown.length === 0 ? (
                props.assessmentDetails && props.assessmentDetails.enable_report ? (
                  <button
                    className="self-respo-submit-button"
                    onClick={() =>
                      props.handleSelfReportDownload(
                        props.assessmentDetails.id,
                        props.assessmentDetails.participant__id,
                        props.assessmentDetails.instrument__instrument_name
                      )
                    }
                  >
                    Download
                  </button>
                ) : (
                  <DropdownToggle className="disabled">DOWNLOAD</DropdownToggle>
                )
              ) : (
                <DropDown
                  downloadReportDropdown={props.downloadReportDropdown}
                  handlePdfDownload={props.handlePdfDownload}
                />
              )}
            </div>
          </div>

        )}
      </div>
    </ResponsiveDashboardcardlayout>
  );
};

export default ResponsiveDownloadReports;



// WEBPACK FOOTER //
// ./src/new/Components/Reports/Download-Reports/Responsive/DownloadReports.jsx